/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(".hidedd").click(function(){    
$("#closepopup").trigger('click');
});
var acc = document.getElementsByClassName("accordionn");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    $('.accordionn').not(this).removeClass('active');
    $('.panell').not(this.nextElementSibling).css('display','none');
    this.classList.toggle("active");
    var panell = this.nextElementSibling;
    if (panell.style.display === "block") {
      panell.style.display = "none";
    } else {
      panell.style.display = "block";
    }
  });
}
$(".applybtncs").click(function()
{
  setTimeout(function(){
  $(".ad_to_cart_coll").hide();
  },2000)
});
$(document).on('click', '.ad_to_cart_coll', function(){    
  var ID = $(this).attr("data-var_id");
  addItemToCart( ID, 1);    // paste your id product number
});
function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
$(".trigjs")[0].click()
    }   
  }); 
}
$("#upsell-popup").click(function(e)
{
  e.preventDefault();
  var itemsArray=[];
  var mainItem={}; 
  mainItem ["id"]=$("input[name='id']").val();
  mainItem ["quantity"]=$("input[name='quantity']").val();
  var groupID=mainItem.id;
   $(".ProductForm select").each(function(){
    groupID+="_"+$(this).val().toLowerCase();
  });

  let qtyId = Math.random().toString(36).substring(2, 7);

  $(".ProductForm select").each(function(){
    var name=$(this).attr("name");
    var val=$(this).val();
    mainItem[name]=val;
    var subItem={};
    var thisID=$(this).attr("id");
    console.log(thisID);
    subItem ["id"] = parseInt($(".ProductForm .color-option."+thisID).attr("v_id"));
    subItem ["quantity"] = mainItem.quantity;
    if ($(this).hasClass("free_color_on")) {
      subItem ["properties"] = {'_item_type':"subitem",'_group_id':groupID, '_qtyId': qtyId, '_randomId': Math.random().toString(36).substring(2, 7),'_free_color':true};
       }else{
          subItem ["properties"] = {'_item_type':"subitem",'_group_id':groupID, '_qtyId': qtyId, '_randomId': Math.random().toString(36).substring(2, 7)};
       }
    itemsArray.push(subItem);
  });
  if($(".hdnFreeProduct").length){
     $(".hdnFreeProduct").each(function(){
    var subItem={};
    subItem ["id"] = $(this).val();
    subItem ["quantity"] = mainItem.quantity;
    subItem ["properties"] = {'_item_type':"subitem",'_group_id':groupID, '_qtyId': qtyId, '_randomId': Math.random().toString(36).substring(2, 7)};
    itemsArray.push(subItem);
       })
  } 
  $(".ProductForm .color-option").each(function(){
    var name=$(this).attr("name");
    var val=$(this).val();
    mainItem[name]=val;
  });
  mainItem ["properties"]={'_item_type':"main",'_group_id':groupID, '_qtyId': qtyId, '_randomId': Math.random().toString(36).substring(2, 7)};
  itemsArray.unshift(mainItem);
  itemsArray.reverse();
  //return false;
  $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data:{'items': itemsArray
               },
          dataType: 'json', 
          success: function (data) { 
            if($('.upsell-add-modal').length == 0){
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true  //this code is for prestige theme, is to refresh the cart
            }));
            $(".trigjs")[0].click()
            }else{
               $("#Upselladd").addClass('modal--is-active');
                document.dispatchEvent(new CustomEvent('theme:loading:end'), {bubbles: true});
            }
          } 
        });
  //$(".Drawer__Close").trigger('click');
  return false;
});

/* for bundled product other then nail sets*/
$(".bundleProduct").click(function(e){
  e.preventDefault();
  var itemsArray=[];
  var mainItem={};
  mainItem ["id"]=$("input[name='id']").val();
  mainItem ["quantity"]=$("input[name='quantity']").val();
  let qtyId = Math.random().toString(36).substring(2, 7);
  
  var groupID=mainItem.id;
   $(".ProductForm .hdnBundleItems").each(function(){
    groupID+="_"+$(this).attr("data-handle").toLowerCase();
  });
  $(".ProductForm .hdnBundleItems").each(function(){
    
    var subItem={};
    subItem ["id"] = $(this).val();
    subItem ["quantity"] = mainItem.quantity;
    subItem ["properties"] = {'_item_type':"subitem",'_group_id':groupID, '_qtyId': qtyId};
    itemsArray.push(subItem);
  });
  mainItem ["properties"]={'_item_type':"main",'_group_id':groupID, '_qtyId': qtyId};
  itemsArray.unshift(mainItem);
  itemsArray.reverse();
  console.log(itemsArray);
  //return false;
   $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data:{'items': itemsArray
               },
          dataType: 'json', 
          success: function (data) { 
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true  //this code is for prestige theme, is to refresh the cart
            }));
            $(".trigjs")[0].click()
          } 
   });
  
  return false;
});



$(document).on('change','.line-item-property__field select',function(e){
  e.preventDefault(); 
  var firstOption = $(this).find('option:first');
  firstOption.prop('disabled', true);
  var selectedOption = $(this).find('option:selected');
  var dataId = selectedOption.data('id');
  var totalCount = $('[data-count-total]').data('count-total');
  var colorOptionInput = $(this).parents('.input_wrapper').find('input');
  $("button.Custom_AddToCart.Button").prop("disabled", false);
  console.log(dataId);
  colorOptionInput.attr('v_id', dataId);
  checkData();
});	
function checkData(){	
  var totalCount = $('[data-count-total]').data('count-total');
  $('.ProductForm__Variants .line-item-property__field select').each(function(){
    var val = $(this).val();
  });
   var requiredval='true';
  $(".required option:selected").each(function(){
  	if($(this).val()=='None-selected')
    {
		requiredval='false';
        return false;
    }
  })
  if(requiredval == 'false')  
  {
    $(".ProductForm__AddToCart").removeAttr("data-action");
     $(".ProductForm__AddToCart").attr("disabled","disabled");
     $(".shopify-payment-button__button").attr("disabled","disabled");
     $(".ProductForm__AddToCart").removeClass("add_to_cart_on");
  }
  else
  {
    $(".ProductForm__AddToCart").attr("data-action","add-to-cart");
    $(".ProductForm__AddToCart").removeAttr("disabled");
    $(".shopify-payment-button__button").removeAttr("disabled");
    $(".ProductForm__AddToCart").addClass("add_to_cart_on");
  }
}


$(document).on("change",".SizeSwatch__Radio",function(){

 var requiredval='true';
  $(".required option:selected").each(function(){
  	if($(this).val()=='None-selected')
    {
		requiredval='false';
        return false;
    }
    
  
  })

  if(requiredval == 'false')  
  {
    $(".ProductForm__AddToCart").removeAttr("data-action");
     $(".ProductForm__AddToCart").attr("disabled","disabled");
     $(".shopify-payment-button__button").attr("disabled","disabled");
  }
  else
  {
    $(".ProductForm__AddToCart").attr("data-action","add-to-cart");
    $(".ProductForm__AddToCart").removeAttr("disabled");
         $(".shopify-payment-button__button").removeAttr("disabled");
  }
})
// $('#color-option').change(function(){
//   var code = $(this).val().toLowerCase();
//   if(code != 'non-selected'){
//     $('[data-option-1] .Grid__Cell img').attr('src', $('[data-get-image] .'+code).attr('src')).css('opacity','1');
//   }else{
//     $('[data-option-6] [data-6] img').attr('src', 'https://cdn.shopify.com/s/files/1/0272/7598/4975/files/2309830-200.png?v=1591203438').css('opacity','0.2'); 
//   }
// });

// $('#color-option1').change(function(){
//   var code = $(this).val().toLowerCase();
//   if(code != 'non-selected'){
//     $('[data-option-3] [data-1] img, [data-option-6] [data-1] img').attr('src', $('[data-get-image] .'+code).attr('src')).css('opacity','1');
//   }else{
//     $('[data-option-6] [data-6] img').attr('src', 'https://cdn.shopify.com/s/files/1/0272/7598/4975/files/2309830-200.png?v=1591203438').css('opacity','0.2'); 
//   }
// });

// $('#color-option2').change(function(){
//   var code = $(this).val().toLowerCase();
//   if(code != 'non-selected'){
//     $('[data-option-3] [data-2] img, [data-option-6] [data-2] img').attr('src', $('[data-get-image] .'+code).attr('src')).css('opacity','1');
//   }else{
//     $('[data-option-6] [data-6] img').attr('src', 'https://cdn.shopify.com/s/files/1/0272/7598/4975/files/2309830-200.png?v=1591203438').css('opacity','0.2'); 
//   }
// });

// $('#color-option3').change(function(){
//   var code = $(this).val().toLowerCase();
//   if(code != 'non-selected'){
//     $('[data-option-3] [data-3] img, [data-option-6] [data-3] img').attr('src', $('[data-get-image] .'+code).attr('src')).css('opacity','1');
//   }else{
//     $('[data-option-6] [data-6] img').attr('src', 'https://cdn.shopify.com/s/files/1/0272/7598/4975/files/2309830-200.png?v=1591203438').css('opacity','0.2'); 
//   }
// });

// $('#color-option4').change(function(){
//   var code = $(this).val().toLowerCase();
//   if(code != 'non-selected'){
//     $('[data-option-6] [data-4] img').attr('src', $('[data-get-image] .'+code).attr('src')).css('opacity','1');
//   }else{
//     $('[data-option-6] [data-6] img').attr('src', 'https://cdn.shopify.com/s/files/1/0272/7598/4975/files/2309830-200.png?v=1591203438').css('opacity','0.2'); 
//   }
// });

// $('#color-option5').change(function(){
//   var code = $(this).val().toLowerCase();
//   if(code != 'non-selected'){
//     $('[data-option-6] [data-5] img').attr('src', $('[data-get-image] .'+code).attr('src')).css('opacity','1');
//   }else{
//     $('[data-option-6] [data-6] img').attr('src', 'https://cdn.shopify.com/s/files/1/0272/7598/4975/files/2309830-200.png?v=1591203438').css('opacity','0.2'); 
//   }
// });

// $('#color-option6').change(function(){
//   var code = $(this).val().toLowerCase();
//   if(code != 'non-selected'){
//     $('[data-option-6] [data-6] img').attr('src', $('[data-get-image] .'+code).attr('src')).css('opacity','1');
//   }else{
//     $('[data-option-6] [data-6] img').attr('src', 'https://cdn.shopify.com/s/files/1/0272/7598/4975/files/2309830-200.png?v=1591203438').css('opacity','0.2'); 
//   }
// });

$.ajax({
  url: 'https://judge.me/api/v1/widgets/all_reviews_count',
  method: 'GET',
  data: {
 "api_token": "9wlY4nmI4HYf4eYLPZY7Yz3571o", 
    "shop_domain": "sistacoau.myshopify.com"
  },
  beforeSend: function(jqxhr, settings) {
    jqxhr._data = settings.url.split("?").pop();
  },
  success: function(data, textStatus, jqXHR) {
    var data1 = data.all_reviews_count ;
    
    $.ajax({
  url: 'https://judge.me/api/v1/widgets/all_reviews_count',
  method: 'GET',
  data: {
 "api_token": "30XgQCQEI6rYJ5tPNBQduhe6qvE", 
    "shop_domain": "sistacouk.myshopify.com"
  },
  beforeSend: function(jqxhr, settings) {
    jqxhr._data = settings.url.split("?").pop();
  },
  success: function(data, textStatus, jqXHR) {
var data2 = data.all_reviews_count ;
     $.ajax({
  url: 'https://judge.me/api/v1/widgets/all_reviews_count',
  method: 'GET',
  data: {
 "api_token": "Bt2DkY3lV_Y89Dmc_ZzH1_OrpOQ", 
    "shop_domain": "sistacoca.myshopify.com"
  },
  beforeSend: function(jqxhr, settings) {
    jqxhr._data = settings.url.split("?").pop();
  },
  success: function(data, textStatus, jqXHR) {
var data3 = data.all_reviews_count ;
         $.ajax({
  url: 'https://judge.me/api/v1/widgets/all_reviews_count',
  method: 'GET',
  data: {
 "api_token": "GgfCON_hjn0wRJWtEqkT8n1IjVs", 
    "shop_domain": "sistacous.myshopify.com"
  },
  beforeSend: function(jqxhr, settings) {
    jqxhr._data = settings.url.split("?").pop();
  },
  success: function(data, textStatus, jqXHR) {
var data4 = data.all_reviews_count ;
  
 $("#cstm-count-section").text(data1+data2+data3+data4);
  }
})
 
  }
})
  }
})

   
  }
});


setTimeout(function(){
  $('div.ZoomyWishlistPageGrid:not(:has(span.zprice))').hide();
},2000)

function readmore() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("moree");
  var btnText = document.getElementById("myBtn");
  console.log(dots);
  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Read more"; 
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "Read less"; 
    moreText.style.display = "inline";
  }
}


// Protection Product AND Cookies
if($('.custom-template-e-gift-cart').length == 0){
if(window.theme.protectionProduct && window.theme.protectionProduct != ''){
  $(document).on('click', '.protection-remove', function () {
    setCookie('protection_product', 'true', 1);
  })


  $( document ).ajaxComplete(function( event, xhr, settings ) {
    if ( settings.url == '/cart/add.js' ) {
      protectionProduct()
    }
  });

  function protectionProduct() {
    var checkProtectionProduct = true;
    var protectionProductId = window.theme.protectionProduct;


    fetch('/cart.js').then(res => res.json()).then((cart) => {
      var getCartItem = cart.items;
      for (let i = 0; i < getCartItem.length; i++) {
        if (getCartItem[i].id == protectionProductId) {
          checkProtectionProduct = false;
        }
      }
    })

    const checkCookies = getCookie('protection_product')

    if (checkCookies == 'true') {
      checkProtectionProduct = false;
    }

    setTimeout(function () {
      if (checkProtectionProduct) {
        let protectionProductData = {
          'updates': {}
        };
        protectionProductData.updates[protectionProductId] = 1;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(protectionProductData)
        }).then((data) => {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        })
      }
    }, 3000)
  }

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
}
}
$(".remove-item.found").bind("click", function () {
            $("#color-option")[0].selectedIndex = 0;
 checkData();
 kit_selected_image();
        });

$(".remove-item.1").bind("click", function () {
            $("#color-option1")[0].selectedIndex = 0;
  checkData();
 kit_selected_image();
        });
      
    $(".remove-item.2").bind("click", function () {
            $("#color-option2")[0].selectedIndex = 0;
  checkData();
 kit_selected_image();
        });
$(".remove-item.3").bind("click", function () {
            $("#color-option3")[0].selectedIndex = 0;
  checkData();
 kit_selected_image();
        });

$(".remove-item.4").bind("click", function () {
            $("#color-option4")[0].selectedIndex = 0;
  checkData();
 kit_selected_image();
        });

$(".remove-item.5").bind("click", function () {
            $("#color-option5")[0].selectedIndex = 0;
  checkData();
 kit_selected_image();
        });

$(".remove-item.6").bind("click", function () {
            $("#color-option6")[0].selectedIndex = 0;
  checkData();
 kit_selected_image();
        });

$(".remove-item.7").bind("click", function () {
            $("#color-option7")[0].selectedIndex = 0;
  checkData();
 kit_selected_image();
        });


// ======================== kit Product Start: Rb ========================
$(document).on('click','.js-kit_bundler-products-picker-trigger_button',function(){
  if($(this).parents('.kit_bundler-products-picker').find('.js-kit_bundler-products-picker-products').hasClass('active-kit-picker')){
   $('.js-kit_bundler-products-picker-products').hide();
   $('.js-kit_bundler-products-picker-products').removeClass('active-kit-picker');
   // $(this).parents('.kit_bundler-products-picker').find('.js-kit_bundler-products-picker-products').toggleClass('active-kit-picker');
  }else{
    $('.js-kit_bundler-products-picker-products').hide();
    $('.js-kit_bundler-products-picker-products').removeClass('active-kit-picker');
    $(this).parents('.kit_bundler-products-picker').find('.js-kit_bundler-products-picker-products').toggleClass('active-kit-picker');
    $(this).parents('.kit_bundler-products-picker').find('.js-kit_bundler-products-picker-products').toggle();       
  }
});

$(document).on('click','.js-kit_bundler-products-picker-products-product_button',function(){
    var get_img = $(this).data('image-src');
    var get_name = $(this).data('kit_name');
    $(this).parents('.kit_bundler-products-picker').find('.kit_image_line_item').val(get_img);
    $(this).parents('.kit_bundler-products-picker').find('.kit_name_line_item').val(get_name);
    $(this).parents('.kit_bundler-products-picker').addClass('selected-kit-product-count');    
    $(this).parents('.kit_bundler-products-picker').find('.js-kit_bundler-products-picker-trigger_button').html('<img src="'+get_img+'">'); 
    $('.js-kit_bundler-products-picker-products').hide();
    $('.js-kit_bundler-products-picker-products').removeClass('active-kit-picker');
    var numItems = $('.selected-kit-product-count').length;
    $('.js-kit_bundler-products_heading-count').html(numItems);
    var total_count = $('.kit_bundler-products').data('totalcount');
    if(total_count == numItems){
     $('.custom-dummy-button-kit-bundle').addClass('main-button-trigger-on');
       $('.early-offer-product').show();
    }else{
     $('.custom-dummy-button-kit-bundle').removeClass('main-button-trigger-on');
       $('.early-offer-product').hide();
    }

});
$(document).on('click','.main-button-trigger-on',function(){  
     jsonObj = [];
    var group_id = $('#main_group_id').val();
    let discountCode = document.querySelector('input[name="properties[_discount_code]"]');
    let discountCodeProduct = document.querySelector('input[name="properties[_discount_code_product]"]');
    if (discountCode && discountCodeProduct) {
      var discountCodeProductValue = discountCodeProduct ? discountCodeProduct.value : '';
      discountCodeProductValue = discountCodeProductValue.replace(/^gid:\/\/shopify\/ProductVariant\//, '');
      var discountCodeValue = discountCode ? discountCode.value : '';
    }
    console.log(discountCodeValue, discountCodeProductValue);
    let qtyId = Math.random().toString(36).substring(2, 7);
    let color_option = { 
        _item_type: 'main',
        _group_id:group_id,
        _qtyId:qtyId,
        _randomId: Math.random().toString(36).substring(2, 7),
        _discountCode: discountCodeValue,
        _discountCodeProduct: discountCodeProductValue
    };
    $('.kit_bundler-inner-select .select').each(function(index){
      var dataId= $(this).find('option:selected').data('id'); 
      color_option[`Colour_option${index + 1}`] = this.value;
      item2 = {}
      item2 ["id"] = parseInt(dataId);
      item2 ["quantity"] = 1;
      item2 ["properties"] = {'_item_type':"subitem",'_group_id':group_id, '_qtyId': qtyId, '_randomId': Math.random().toString(36).substring(2, 7)};
      jsonObj.push(item2);
    });
     if ($('.kit_bundler-promo').hasClass('promo-available-for-add')) {
     const selectedValue = $('.SizeSwatch__Radio:checked').val();
      console.log(selectedValue);
   if (selectedValue && !selectedValue.includes("Foundation")) {   
    var dataId = String($('.promo-available-for-add').data('id'));
    var ids = dataId.indexOf(',') !== -1 ? dataId.split(',') : [dataId];

    ids.forEach(function(id) {
        var item3 = {};
        item3["id"] = parseInt(id.trim(), 10); // Ensure any extra spaces are trimmed and parse as an integer
        item3["quantity"] = 1;
        item3["properties"] = {'_item_type': 'subitem', '_group_id': group_id, '_qtyId': qtyId, '_randomId': Math.random().toString(36).substring(2, 7)};
        jsonObj.push(item3);
    });
   }
}
  item9 = {};
  item9 ["id"] = parseInt($('.ProductForm [name="id"]').val());
  item9 ["quantity"] = 1;
  item9 ["properties"] = color_option;

  jsonObj.push(item9);
  $('.early-black-friday-offer .activep').each(function(){
      var dataId= $(this).attr('data-variant-id');
      var key = $(this).attr('date-attr');
      item2 = {}
      item2 ["id"] = parseInt(dataId);
      item2 ["quantity"] = 1;
      item2 ["properties"] = {[key]: 'Free Mystery Gift'};
      jsonObj.push(item2);
    });
    $.ajax({
      type: "POST", 
      url: '/cart/add.js',
      data: {items: jsonObj },
      dataType: "json",
      success: function(response) {
        console.log('success');
         $('.early_friday_wrapper').hide();
         setTimeout(function() {	
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {	
          bubbles: true	
          }));

          const mainProduct = response.items.find(item => 
            item.properties && item.properties._item_type === 'main'
          );
  
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: mainProduct,
              quantity: mainProduct.quantity
            }
          }));
           $(".trigjs")[0].click();
            },200);
      }
    });
});
$(document).on('click','.trigger-next-variant-input',function(){
  $('.custom-button-variant-for-kit-bundle input:checked').parents('.custom-button-variant-for-kit-bundle').next().find('input').trigger('click');
});
$(document).on('click','.trigger-next-variant-input',function(){
  $('.custom-button-variant-for-kit-bundle input:checked').parents('.custom-button-variant-for-kit-bundle').next().find('input').trigger('click');
});
$(document).on('click', '.custom-button-variant-for-kit-bundle input', function() {
    $('.custom-button-variant-for-kit-bundle').css('pointer-events','none');
    if ($('button').hasClass('custom-dummy-button-kit-bundle')) {
        let option_name = $(this).val();
        let index_input = parseInt($(this).attr('data-index'));
        let past_index = parseInt(localStorage.getItem("pastset"));

        $('.kit-product-content-main-wraper').html('<img class="loader-image-kit" src="https://cdn.shopify.com/s/files/1/0577/5428/8322/files/Spinner-1s-200px.gif?v=1664170504">');
        $('.custom-dummy-button-kit-bundle').removeClass('main-button-trigger-on');
        $('.early-offer-product').hide();
        setTimeout(() => {
            let cur_url = window.location.href;
            let get_url = $('body').hasClass('custom-template-blackfriday') ?
                $('.get_blackfriday_id[data-url="' + cur_url.split('=')[1] + '"]').data('id') :
                cur_url;
           
            $.ajax({
                url: get_url,
                success: function(result) {
                    updateContent(result);
                    if (index_input > past_index) {
                        updateOldSelections(past_index);
                    }
                    if (index_input < past_index) {
                        updateOldSelections(past_index);
                    }
                    $('.tag_filter_wrapper .Linklist__Item').click(function() {
                        handleTagFilterClick($(this));
                    });
                  closecolorSelection();
                     $('.variant_trigger').click(function(){
      $('.custom-button-variant-for-kit-bundle input[value="Deluxe Set"]').trigger('click');
    });
                    if (windowSize <= 576) {
                        $(".kit-product-images-selector").clone().insertAfter(".kit_bundler-promo");
                    }
                   $('.custom-button-variant-for-kit-bundle').css('pointer-events','auto');
                }
            });
        }, 100);
    }
});
function updateContent(result) {
    const elementsToUpdate = [
        { selector: '.kit-product-content-main-wraper', source: '.kit-product-content-main-wraper' },
        { selector: '.kit-product-images-selector', source: '.kit-product-images-selector' },
        { selector: '.custom-dummy-button-kit-bundle', source: '.custom-dummy-button-kit-bundle' },
        { selector: '.Product__InfoWrapper .ProductMeta__Title', source: '.Product__InfoWrapper .ProductMeta__Title' },
        { selector: '.mobileview_ProductMeta .ProductMeta__Title', source: '.Product__InfoWrapper .ProductMeta__Title' },
        { selector: '.kit_bundler-promo', source: '.kit-product-content-main-wraper .kit_bundler-promo' },
        { selector: '.M_ProductMeta__PriceList', source: '.Product__InfoWrapper .ProductMeta__PriceList' },
        { selector: '.what_in_set', source: '.what_in_set' },
        { selector: '.payment_option_container', source: '.payment_option_container' },
        { selector: '.how_to_use', source: '.how_to_use' }
    ];
    elementsToUpdate.forEach(element => {
        $(element.selector).html($(result).find(element.source).html());
    });
     const productCards = document.querySelectorAll('.product-card');
    productCards.forEach(card => {
        card.addEventListener('click', function(e) {
          e.preventDefault()
            const parentBlock = this.closest('.product-block');
            if (parentBlock) {
                parentBlock.querySelectorAll('.product-card').forEach(sibling => {
                    sibling.classList.remove('activep');
                });
                this.classList.add('activep');
            }
        });
    }); 
}

function updateOldSelections(past_index) {
    let index = past_index - 1;
    let get_options = $('.custom-button-variant-for-kit-bundle:eq('+index+') input').attr('data-old');

    if (get_options) 
        console.log(get_options);
        let old_selected = get_options.split(",");
        old_selected.forEach((value, key) => {
            $('.kit_bundler-inner-select select:eq(' + key + ')').val(value).trigger('change');
           console.log($('.all-wrapper [data-title="'+value+'"]'));
           $('.all-wrapper .all-item[data-title="'+value+'"]').trigger('click');
        });
    }
function closecolorSelection(){
  const closeProductListIcons = document.querySelectorAll('.close_product_list');
    closeProductListIcons.forEach(icon => {
        icon.addEventListener('click', function() {
           const parent = this.closest('.color-selection-wrapper');
            if (parent) {
                parent.classList.remove('active');
            }
            document.body.classList.remove('is-visible');
        });
    });
}
  $(document).on('change','.kit_bundler-inner-select select', function(){
  var get_val =  $(this).val();
    if(get_val != 'None-selected'){
        $(this).addClass('select');
          var total_count = $('.kit_bundler-products-select-box').data('totalcount');
          var numItems = $('.select').length;

          var main_id = $('.kit_bundler-products-select-box').data('mainid');
          var main_group_id = main_id;

          $('.kit_bundler-products-select-box .select').each(function(){ 
            var get_this_val = $(this).val();
              main_group_id += '_'+get_this_val;
          });
      
    
          $('input#main_group_id').val(main_group_id);
      
            if(total_count == numItems){
               $('.custom-dummy-button-kit-bundle').addClass('main-button-trigger-on');
               $('.blackfriday_colourchart').addClass('disabled_of');
               $('.early-offer-product').show();
            }else{
              $('.blackfriday_colourchart').removeClass('disabled_of');	
              $('.custom-dummy-button-kit-bundle').removeClass('main-button-trigger-on');
               $('.early-offer-product').hide();
            }
    }else{
        $(this).removeClass('select');
        $('.custom-dummy-button-kit-bundle').removeClass('main-button-trigger-on');
        $('.blackfriday_colourchart').removeClass('disabled_of');
       $('.early-offer-product').hide();
    }


  $('.new-grid input').prop('checked', false);
  $('.new-grid input').attr('disabled', 'disabled');
  $('.kit_bundler-inner-select select').each(function(){
    var val = $(this).val();
    $('.new-grid input').each(function(e){
      var $this = $(this);
      var valIn = $this.attr('id');
      if(val == valIn) {
        $this.prop('checked', true);
        $this.removeAttr('disabled');
      }
    });
  });
  $('.kit_bundler-inner-select select').each(function(){
    if($(this).val() == 'None-selected'){
      $('.new-grid input').removeAttr('disabled');
      return false;
    }
  });
    kit_selected_image();
  });

function kit_selected_image(){
  var create_old_added_data = [];
  $('.kit_bundler-inner-select .select').each(function(e){
    var get_this_val = $(this).val();
    create_old_added_data.push(get_this_val);
    }); 
  var create_array = create_old_added_data.join(',');
  $('.custom-button-variant-for-kit-bundle input:checked').attr('data-old',create_array);
  let get_index = parseInt($("input[name='option-0']:checked").attr('data-index'));
  localStorage.setItem("pastset", get_index);
}

  $(document).on('click','.clear-images-close', function(){
    var get_index = $(this).data('index');
    $('.kit_bundler-inner-select .select:eq('+get_index+')').val('None-selected').trigger('change');
    kit_selected_image();
  });
  $(document).on('click','.clear-select-box', function(){
    var get_index = $(this).data('index');
    $(this).parents('.kit_bundler-inner-select').find('select').val('None-selected').trigger('change');
    kit_selected_image();
  });
$(document).ready(function(){
    if($( window ).width() < 640){
    $('.hidden-phone').remove();
  }
  if($('.cstm-shopi').hasClass('kit-product-images-selector')){
      $('.custom-button-add-to-cart-trigger').attr("data-action","add-to-cart");
  }
	});	
  $(document).on('click', '.disabled_of .bf_dummy_button', function(event) {	
    $('.custom-dummy-button-kit-bundle  ').trigger('click');	
  });	
  $(".botom_img").click(function() {	
    $('html, body').animate({	
      scrollTop: $(".ProductForm").offset().top - 100	
    }, 1200);	
  });
// ======================== kit Product End: Rb ========================


 const an_height = document.getElementById('shopify-section-announcement');

if(an_height){
 document.documentElement.style.setProperty('--announcement-bar-height', document.getElementById('shopify-section-announcement').offsetHeight + 'px');
}
  // End issue slider height
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
let active_has = getUrlParameter('faq_title');
if(active_has){
$('.FaqSummary__Item').removeClass('is-active');
  $('[data-title="#'+ active_has +'"]').addClass('is-active');
  let clickedBtnID = $('[data-title="#'+ active_has +'"] a').attr('href');
    $('html, body').animate({
        scrollTop: $(clickedBtnID).offset().top
    }, 2000);
  }
$(document).ready(function(){
  function getFieldName(input) {
    return input.id.charAt(0).toUpperCase() + input.id.slice(1);
}
  function showSucces(input) {
    const formControl = input.parentElement;
     if(input.id == "typeofinquiry"){
    formControl.className = 'Form__Select Select Select--primary Form__Item success';
     }else{
        formControl.className = 'Form__Item success';
     }
}
  function showError(input, message) {
    const formControl = input.parentElement;
    if(input.id == "typeofinquiry"){
    formControl.className = 'Form__Select Select Select--primary Form__Item error';
    }else{
       formControl.className = 'Form__Item error';
    }
    const small = formControl.querySelector('small');
    small.innerText = message;
}
  function checkEmail(input) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(re.test(input.value.trim())) {
        showSucces(input);
         return true;
    }else {
        showError(input,'Email is not invalid');
    }
}

       function checkRequired(inputArr) {
         let length = inputArr.length;
         let check_sucess = false;
         let success_input = 0;
    inputArr.forEach(function(input){
        if(input.value.trim() === ''){
            showError(input,`${getFieldName(input)} is required`)
        }else {
            showSucces(input);
          success_input++;
          if(length == success_input){
              const email_check = document.getElementById('email');
            check_sucess = checkEmail(email_check);
           
          }
        }
    });
          return check_sucess;
}
    $(".freshdesk_submit").click(function(e) {
        var yourdomain = 'https://sistaco.freshdesk.com'; // Your freshdesk domain name. Ex., yourcompany
        var api_key = 'EJUNdyYtGFBFwdYRkOHk'; // Ref: https://support.freshdesk.com/support/solutions/articles/215517-how-to-find-your-api-key
       const firstname = document.getElementById('firstname');
      const typeofinquiry_e = document.getElementById('typeofinquiry');
       const lastname = document.getElementById('lastname');
      const email_e = document.getElementById('email');
      const mainmessage = document.getElementById('mainmessage');
      let success = checkRequired([typeofinquiry_e,firstname, lastname, email_e, mainmessage]);
      if(success){
            $('.loadersmall').show();
        $('.freshdesk_submit').prop("disabled", true);
        let typeofinquiry;
        if($("[name='ordernumber']").val() != ""){
         typeofinquiry = $("[name='typeofinquiry']").val() + " ORDER NO AU #" +  $("[name='ordernumber']").val();
          }else{
          typeofinquiry = $("[name='typeofinquiry']").val() + "| AU";
          }
        let name = $('.firstname').val() + " " + $('.lastname').val();
        let email = $('.email').val();
        let description =$('.mainmessage').val();
        let order_number =  $("[name='ordernumber']").val();
        var formdata = new FormData();
         
        formdata.append('name', name);
        formdata.append('description', description);
        formdata.append('email', email);
        formdata.append('subject',typeofinquiry);
        formdata.append('group_id',65000072515);
      //  formdata.append('requester_id',order_number);
        formdata.append('priority', '2');
        formdata.append('status', '2');
        if( document.getElementById("myFile").files.length > 0 ){
             var totalfiles = document.getElementById('myFile').files.length;
           for (var index = 0; index < totalfiles; index++) {
            formdata.append("attachments[]", document.getElementById('myFile').files[index]);
            }
        }
        $.ajax(
          {
            url: "https://sistaco.freshdesk.com/api/v2/tickets",
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
              "Authorization": "Basic " + btoa(api_key + ":x")
            },
            data: formdata,
            success: function(data, textStatus, jqXHR) {
                  $('.loadersmall').hide();
              $('#freshdeskform').hide();
              $('.PageContent .Rte').hide();
              $('#result').append('<p><svg class="svg-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M511.7 112.5c-220.5 0-399.2 178.7-399.2 399.2s178.7 399.2 399.2 399.2C732.2 911 911 732.3 911 511.8c0-220.5-178.8-399.3-399.3-399.3z m254.6 291.7L480.6 689.9c-19.4 19.4-51.2 19.4-70.6 0L257.1 537c-19.4-19.4-19.4-51.2 0-70.6 19.4-19.4 51.2-19.4 70.6 0L445.3 584l250.4-250.4c19.4-19.4 51.2-19.4 70.6 0 19.4 19.5 19.4 51.3 0 70.6z m0 0"  /></svg>Thank you for your message.We will get back to you shortly.</p>');
             // $('#code').text(jqXHR.status);
              //$('#response').html(JSON.stringify(data, null, "<br/>"));
              return false;
            },
            error: function(jqXHR, tranStatus) {
              $('#result').text('Error');
              $('#code').text(jqXHR.status);
              x_request_id = jqXHR.getResponseHeader('X-Request-Id');
              response_text = jqXHR.responseText;
              $('#response').html(" Error Message : <b style='color: red'>"+response_text+"</b>.<br/> Your X-Request-Id is : <b>" + x_request_id + "</b>. Please contact support@freshdesk.com with this id for more information.");
              return false;
            }
          }
        );
      }
      }
    );
});
$( document ).ready(function() {
  var maxChars = 200;
  var textLength = 0;
  var comment = "";
  var outOfChars = 'You have reached the limit of ' + maxChars + ' characters';

  /* initalize for when no data is in localStorage */
  var count = maxChars;
  $('#characterLeft').text(count + ' characters left');

  /* fix val so it counts carriage returns */
  $.valHooks.textarea = {
    get: function(e) {
      return e.value.replace(/\r?\n/g, "\r\n");
    }
  };

  function checkCount() {
    if($('#giftmessage').length > 0){
    textLength = $('#giftmessage').val().length;
    if (textLength >= maxChars) {
      $('#characterLeft').text(outOfChars);
    }
    else {
      count = maxChars - textLength;
      $('#characterLeft').text(count + ' characters remaining');
    }
      }
  }

  /* on keyUp: update #characterLeft as well as count & comment in localStorage */
  $('#giftmessage').keyup(function() {
    checkCount();
    comment = $(this).val();
    localStorage.setItem("comment", comment);
  });

  /* on pageload: get check for comment text in localStorage, if found update comment & count */
  if (localStorage.getItem("comment") != null) {
    $('#giftmessage').text(localStorage.getItem("comment"));
    checkCount();
  }
});
  (function () {
        window.onpageshow = function() {
          if (window.theme.showPageTransition) {
            var pageTransition = document.querySelector('.PageTransition');

            if (pageTransition) {
              pageTransition.style.visibility = 'visible';
              pageTransition.style.opacity = '0';
            }
          }
          // When the page is loaded from the cache, we have to reload the cart content
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        };
      })();

 var windowSize = $(window).width();
 document.addEventListener("DOMContentLoaded", adjustThumbnailHeight);
window.addEventListener("resize", adjustThumbnailHeight);
function adjustThumbnailHeight() {
  var slideshow = document.querySelector('.Product__Slideshow .flickity-viewport');
  var thumbnails = document.querySelector('.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller');
  if (slideshow && thumbnails) {
    if (window.innerWidth < 500) {
      var slideshowHeight = slideshow.offsetHeight;
      thumbnails.style.height = slideshowHeight + 'px';
    } else {
      thumbnails.style.height = 'auto';
    }
  }
}


if($('.kit_bundler-inner-select').length > 0 || $('.cstm-equalgrid').length > 0 || $('.ProductForm__Option').length > 0){
  $('.ProductForm__Variants').css('width','100%');
  $('.template-product .btn_wraper').css('width','100%');
  $('.template-product .btn_wraper').css('margin-left','0px');
}
const circlePlayButton = $(".play-button-wrapper");
$(".play-button-wrapper").click(function(){
  console.log($(this).parent());
  $(this).parent().find('video')[0].play();
  $(this).hide();
});
localStorage.clear('currentTime');
localStorage.clear('targetTime');
$('a.read_more').click(function() {
  $('div.read_more').show();
 $('div.read_lesh').hide();
});
$('a.read_lesh').click(function() {
  $('div.read_lesh').show();
 $('div.read_more').hide();
});

  var option ='';
    var windowsize = $(window).width();
        if (windowsize > 767) {
           option = '{ "autoPlay": false,"pageDots":false,"prevNextButtons":false,"wrapAround": true,"cellAlign":"left"}';
        }else{
            option = '{ "autoPlay": true,"pageDots":false,"prevNextButtons":false,"wrapAround": true,"cellAlign":"left","prevNextButtons":true }';
        }
  $('.footer-icon-inner-wraper').attr('data-flickity',option);
if (windowSize <= 576) {
$(".kit-product-images-selector").clone().insertAfter(".kit_bundler-promo");
// $('.mobileview_ProductMeta + .cstm-shopi').remove(); 
}
$('.Faq__Item_product .Faq__Question').click(function() {
  $(this).siblings().css('height', 'auto')
});
if($('.upsell-add-modal').length > 0){
  console.log('in Upsell module');
$(".clss").click(function(e)
{
  $('body').removeClass('modal-open');
    $("#Upselladd").removeClass('modal--is-active');
     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true  //this code is for prestige theme, is to refresh the cart
            }));
            $(".trigjs")[0].click();
})
$(".upsell_add").click(function(e)
{
  //  $('body').removeClass('modal-open');
    $("#Upselladd").removeClass('modal--is-active');
 var valu = $('.cstmradio:checked').val();
   $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data:{quantity: 1,id:valu},
          dataType: 'json', 
          success: function (data) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true  //this code is for prestige theme, is to refresh the cart
            }));
            $(".trigjs")[0].click();
          } 
        });
})
}
$(".upsellProduct").click(function(e){
  e.preventDefault();
  var itemsArray=[];
  var mainItem={};
  mainItem.id=$(this).parents('.modal__centered').find("input[name='id']").val();
  mainItem.quantity=$(this).parents('.modal__centered').find("input[name='quantity']").val();
  mainItem["properties[_item_type]"]="main";
  
  var groupID=mainItem.id;
   $(".ProductFormupsell .hdnBundleItems").each(function(){
    groupID+="_"+$(this).attr("data-handle").toLowerCase();
  });
  $(".ProductFormupsell .hdnBundleItems").each(function(){
    var subItem={};
    subItem.id=$(this).val();
    subItem.quantity=mainItem.quantity;
    subItem["properties[_item_type]"]="subitem";
    subItem["properties[_group_id]"]=groupID;
    itemsArray.push(subItem);
  });
  mainItem["properties[_group_id]"]=groupID;
  itemsArray.unshift(mainItem);
  itemsArray.reverse();
  //return false;
   $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data:{'items': itemsArray
               },
          dataType: 'json', 
          success: function (data) { 
             $("#Upselladd").removeClass('modal--is-active');
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true  //this code is for prestige theme, is to refresh the cart
            }));
            $(".trigjs")[0].click()
          } 
   });
  
  return false;
});



jQuery(document).ready(function(){
  
    var len = jQuery(".landing-custom-testimonial-des li.dot").length;   
    jQuery('section.landing-custom-testimonial-des .carousel-cell[data-index=2]').addClass('selected-center');
    jQuery('button.flickity-prev-next-button.previous, button.flickity-prev-next-button.next, .landing-custom-testimonial-des .flickity-page-dots .dot').click(function(){
        jQuery('section.landing-custom-testimonial-des .carousel-cell').removeClass('selected-center');
        var g = jQuery('section.landing-custom-testimonial-des .carousel-cell.is-selected').attr('data-index');
        var iNum = parseInt(g);
        var add = iNum + 1;
        if(len == iNum){
            add = 1;
        }
        jQuery('section.landing-custom-testimonial-des .carousel-cell[data-index="'+add+'"]').addClass('selected-center');
    });
    jQuery('.landing-custom-testimonial-des .flickity-viewport').mousemove(function(){
        jQuery('section.landing-custom-testimonial-des .carousel-cell').removeClass('selected-center');
        var g = jQuery('section.landing-custom-testimonial-des .carousel-cell.is-selected').attr('data-index');
        var iNum = parseInt(g);
        var add = iNum + 1;
        if(len == iNum){
            add = 1;
        }
        jQuery('section.landing-custom-testimonial-des .carousel-cell[data-index="'+add+'"]').addClass('selected-center');
    });
});

///landing page video js 
  document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});
if (window.screen.width <= 720) {
  $('.custom-dummy-button-kit-bundle').click(function(){
       $('html, body').animate({
        scrollTop: $("#section_new").offset().top
    }, 500);
  });
}


// New Featured Collection


$(".bundle_checkout_btn .checkout_btn").hide();
$(".bundle_checkout_btn .discount_text_area").hide();

$(document).ready(function(){
   $(".left_prodcut .ProductItem__Wrapper").click(function(){
     $(this).find('.ProductItem__ImageWrapper').toggleClass('active');
     let product_show = $(this).parents('.ProductList .Grid__Cell').attr('data-product-title');
     if($(this).find('.ProductItem__ImageWrapper').hasClass('active')){
     $("."+product_show).addClass('active_bundle');
       }else{
       $("."+product_show).removeClass('active_bundle');
       }
     $(this).parents('.ProductItem__Wrapper').each(function(){
       let product_id = $(this).attr('data-variant-id');
     }); 
      let product_pp = $('.ProductItem__PriceList.Heading span.ProductItem__Price.Price').val();
     console.log(product_pp);
     $('.free_prodcut').remove();
     $('.active_bundle').find('.ProductItem__Price').css('text-decoration','none');
      $('.active_bundle').eq(3).find('.product_bundle_price').append('<span class="free_prodcut">&nbsp;&nbsp$0</span>');
   $('.active_bundle').eq(3).find('.ProductItem__Price').css('text-decoration','line-through');
  let total_prodct = $(".active_bundle").length;
   if(total_prodct >= 3){ 
      $(".empty_cart").hide(); 
     $(".bundle_checkout_btn .checkout_btn").show();
     $(".bundle_checkout_btn .discount_text_area").show();
     $(".bundle_checkout_btn .discount_text_area .discount_text").text(total_prodct +' Product Selected');
     if(total_prodct >= 2 && total_prodct <=3){
        $(".bundle_checkout_btn .discount_text_area").show();
       $(".bundle_checkout_btn .discount_text_area .discount_text").show();
       $('.discount_text').text('ADD Free Sustainable Nails Set Of Your Choice');
       $(".bundle_checkout_btn .discount_text_area span").text('Get 1 FREE').hide();
     }else if(total_prodct >= 3 && total_prodct <=4){
       
        $('.discount_text').hide();
       $(".bundle_checkout_btn .discount_text_area span").text('Get 1 FREE').hide();
        $(".bundle_checkout_btn .discount_text_area").hide();
     }else if(total_prodct >= 6){
        $('.discount_text').hide();
       $(".bundle_checkout_btn .discount_text_area span").text('Get 1 FREE').hide();
        $(".bundle_checkout_btn .discount_text_area").hide();
     }
    }
   else if (total_prodct >= 1){
      $(".bundle_checkout_btn .discount_text_area .discount_text").text(total_prodct +' Product Selected');
      $(".empty_cart .product_count span").text(total_prodct);
     $(".bundle_checkout_btn .checkout_btn").hide();
    
   }
}); 
  
   $(".product_bundle_remove-btn").click(function(){
     let product_hide = $(this).parents('.bundle_add_cart .Grid__Cell').attr('data-bundle-product-title');
     $('[data-product-title="'+product_hide+'"]').find('.ProductItem__ImageWrapper').removeClass('active');
      $("."+product_hide).removeClass('active_bundle');
       let total_prodct = $(".active_bundle").length;
       if(total_prodct == 0){
           $(".empty_cart .product_count span").text("0"); 
       }
        else if(total_prodct < 3){  
            $(".empty_cart").show(); 
            $(".bundle_checkout_btn .checkout_btn").hide();
            $(".bundle_checkout_btn .discount_text_area").hide();
        }
      else if (total_prodct <= 1){
           $(".empty_cart .product_count span").text(total_prodct); 
        } 
   });
  
});

$(".checkout_btn").click(function(){
    let all_item = []; 
  
$('.bundle_add_cart .all_collection_product.active_bundle').each(function(){ 
          let varietn_idd = $(this).find(".ProductItem__Wrapper").attr('data-variant-id');
          let sub_itemss = {};
          sub_itemss.id = varietn_idd; 
          sub_itemss.quantiy = 1;
          sub_itemss.properties = {_item_landing:true};
          all_item.push(sub_itemss);
});
  let length = all_item.length;
     $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data:{'items': all_item},
          dataType: 'json', 
          success: function (data) {
             document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true 
            }));
           $(".trigjs")[0].click();
          } 
   });
});
const initializeBodyObservation = () => {
  const targetNode = document.querySelector('#sidebar-cart');
  const config = { attributes: true, childList: true, subtree: true };
  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      for (const addedNode of mutation.addedNodes) {
     // console.log(addedNode.getAttribute('class'));
        if(addedNode.classList){
        if(addedNode.classList.contains('af_new_price')) {
          let cart_update_amt = parseInt(addedNode.textContent.slice(1));
          console.log(cart_update_amt);
          if(cart_update_amt < 105){
          $('.approaching-discount-wrapper').hide();
            }else{
            $('.approaching-discount-wrapper').show();
            }
       }
          }
    }
       if (mutation.type === "childList") {
      console.log("A child node has been added or removed.");
       }
    } 
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}
document.addEventListener("DOMContentLoaded", (event) => {
  if($('body').hasClass('custom-template-blackfriday')){
   $('li[count_var="3"] input').prop('checked', false);
   $('li[count_var="3"] input').trigger('click');
 }
initializeBodyObservation();
});
$('.product-tab-list li').click(function(){
  let active_tab = $(this).attr('data-class');
  console.log(active_tab);
  $('.product-tab-list li').removeClass('active');
  $('.product-tab').removeClass('active');
  $('.'+active_tab).addClass('active');
  $(this).addClass('active');
});




// review container
// Get all elements with the classes '.shopify-block', .'shopify-app-block'
const widgets = document.querySelectorAll('.shopify-block, .shopify-app-block');

// Loop through each element
widgets.forEach(widget => {
  // Create a new div element with the class 'container'
  const container = document.createElement('div');
  container.className = 'Container';

  // Append the widget element to the new container
  widget.parentNode.insertBefore(container, widget);
  container.appendChild(widget);
});
document.addEventListener("DOMContentLoaded", function() {
  var descriptionElements = document.querySelectorAll(".SectionHeader__Description");
  if (descriptionElements.length > 0) {
  descriptionElements.forEach(function(descriptionElement) {
    var readMoreBtn = document.createElement("button");
    readMoreBtn.classList.add("readMoreBtn");
    readMoreBtn.innerText = "Read More";
    descriptionElement.insertAdjacentElement("afterend", readMoreBtn);
    function checkOverflow() {
      var containerHeight = descriptionElement.offsetHeight + 6;
      var contentHeight = descriptionElement.scrollHeight;
      if (contentHeight > containerHeight) {
        readMoreBtn.style.display = "block";
        
      } else {
        readMoreBtn.style.display = "none";
      }
    }
    checkOverflow();
    readMoreBtn.addEventListener("click", function() {
      if (descriptionElement.classList.contains("expanded")) {
        descriptionElement.classList.remove("expanded");
        readMoreBtn.innerText = "Read More";
      } else {
        descriptionElement.classList.add("expanded");
        readMoreBtn.innerText = "Read Less";
      }
    });
    window.addEventListener("resize", checkOverflow);
  });
  }
});
document.addEventListener('DOMContentLoaded', function() {
    let bannerCloned = false;
    function checkScreenSize() {
        if (window.innerWidth < 768) {
            if (!bannerCloned) {
                const mobileBanner = document.querySelector('.banner-image-mobile');
                const clonedBanner = mobileBanner.cloneNode(true);
                const productList = document.querySelector('.ProductList--grid');

                if (productList) {
                    const wrapperDiv = document.createElement('div');
                    wrapperDiv.className = 'Grid__Cell 1/2--phone 1/2--tablet-and-up 1/3--lap-and-up';
                    wrapperDiv.appendChild(clonedBanner);
                    productList.appendChild(wrapperDiv);
                    const topBannerSection = document.querySelector('.top-banner-section.cstm_prod');
                    if (topBannerSection) {
                        topBannerSection.remove();
                    }
                    bannerCloned = true;
                }
            }
        } else {
            bannerCloned = false;
        }
    }

    if (document.body.classList.contains('template-index') || document.body.classList.contains('custom-template-bau')) {
   // checkScreenSize();
    //window.addEventListener('resize', checkScreenSize);
 }
});

document.addEventListener('click', (e) =>{
  if (e.target.matches('button[data-open-filter="true"]')) {
    let drawer = document.querySelector('#collection-filter-drawer');
    let targetLabel = drawer.querySelector(`button[aria-label="${e.target.getAttribute('aria-label')}"]`);
    if(targetLabel.getAttribute('aria-expanded') === 'false'){
      targetLabel.click();
    }
  }
})

document.addEventListener('click', function(event) {
  const allDiv = document.querySelector('.all');
  if (allDiv && !allDiv.contains(event.target)) {
    document.querySelector('.close_product_list').click();
  }
});

document.addEventListener("theme:loading:end", async (e) => {
  await fetch('/cart.js')
    .then(response => response.json())
    .then(async (data) => {
      const gift = data.items.find(item => item.properties && item.properties._buyXGetY === 'true');

      const noParentNeeded = window.discountProduct.find( item => item.productHandle === gift?.handle);
      const isShippingProtection = data.items.find(item => item.id === window.theme.protectionProduct);
      let itemCount = data.item_count;
      if(isShippingProtection){
        itemCount = itemCount - 1;
      }
      
      const giftParents = data.items.filter(item => item.properties && item.properties._item_type === 'main' && item.properties._discountCode?.toLowerCase() === gift?.properties._discountCode?.toLowerCase() && item.properties._discountCodeProduct === gift?.properties._discountCodeProduct);
      if((giftParents.length == 0 && gift && !noParentNeeded?.noParentProduct) || (itemCount === gift?.quantity)){
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: gift.key,
            quantity: 0,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Product removed from cart:", data);
          })
          .finally(() => {
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
              })
            );
          })
          .catch((error) => {
            console.error("Error removing product from cart:", error);
          });
      }
    });
});
document.addEventListener("click", function(e) {
  // see if we clicked (or clicked inside) an <a href="#click_to_top">
  const trigger = e.target.closest('a[href="#click_to_top"]');
  if (!trigger) return;       // bail if it wasn't that link

  e.preventDefault();         // stop the default jump
  const scrollTarget = document.querySelector("#click_to_top");
  const header = document.querySelector('.Header__Wrapper');
  const headerHeight = header ? header.offsetHeight : 0;

  if (scrollTarget) {
    const topPos = scrollTarget.getBoundingClientRect().top + window.scrollY - headerHeight - 300;
    window.scrollTo({
      top: topPos,
      behavior: "smooth"
    });
  }
});

const thresholds = async (e) => {
  const thresholds = {
    tier1:{
      amount: window.theme.tone_threshold_in_cents,
      product: window.theme.tier_1
    },
    tier2:{
      amount: window.theme.ttwo_threshold_in_cents,
      product: window.theme.tier_2
    },
    tier3:{
      amount: window.theme.tthree_threshold_in_cents,
      product: window.theme.tier_3
    },
    tier4:{
      amount: window.theme.tfour_threshold_in_cents,
      product: window.theme.tier_4
    }
  }

  const productAdder = async (variantId) => {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Product added to cart:", data);
      })
      .finally(() => {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
      });
  }

  const productRemover = async (itemIndex, quantity = 0) => {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: itemIndex,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Product removed from cart:", data);
      })
      .finally(() => {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
      })
  }

  await new Promise(resolve => setTimeout(resolve, 500));
  const response = await fetch("/cart.js")
  const cart = await response.json()
  console.log('thresholds :>> ', thresholds);
  
  let cartTotalExcludingProducts = cart.items.reduce((total, item) => {
    if (!window.theme.excludedProducts.includes(item.product_id)) {
      return total + item.line_price;
    }
    return total;
  }, 0);
  
  if(thresholds.tier1.amount && thresholds.tier1.product){ 
    const tier1ProductExists = cart.items.some(item => item.variant_id == thresholds.tier1.product);
    const tier1Product = cart.items.find(item => item.variant_id == thresholds.tier1.product);
    if(cartTotalExcludingProducts >= thresholds.tier1.amount && !tier1ProductExists){ 
      console.log('Threshold 1 met, adding product');
      await productAdder(thresholds.tier1.product);
    } else if(cartTotalExcludingProducts < thresholds.tier1.amount && tier1ProductExists){
      console.log('Threshold 1 not met, removing product');
      await productRemover(tier1Product.key);
    } else if(tier1Product && tier1Product.quantity > 1){
      await productRemover(tier1Product.key, 1);
    }
  }
  
  if(thresholds.tier2.amount && thresholds.tier2.product){ 
    const tier2ProductExists = cart.items.some(item => item.variant_id == thresholds.tier2.product);
    const tier2Product = cart.items.find(item => item.variant_id == thresholds.tier2.product);
    if(cartTotalExcludingProducts >= thresholds.tier2.amount && !tier2ProductExists){ 
      console.log('Threshold 2 met, adding product');
      await productAdder(thresholds.tier2.product);
    } else if(cartTotalExcludingProducts < thresholds.tier2.amount && tier2ProductExists){
      console.log('Threshold 2 not met, removing product');
      await productRemover(tier2Product.key);
    } else if(tier2Product && tier2Product.quantity > 1){
      await productRemover(tier2Product.key, 1);
    }
  }
  
  if(thresholds.tier3.amount && thresholds.tier3.product){ 
    const tier3ProductExists = cart.items.some(item => item.variant_id == thresholds.tier3.product);
    const tier3Product = cart.items.find(item => item.variant_id == thresholds.tier3.product);
    if(cartTotalExcludingProducts >= thresholds.tier3.amount && !tier3ProductExists){ 
      console.log('Threshold 3 met, adding product');
      await productAdder(thresholds.tier3.product);
    } else if(cartTotalExcludingProducts < thresholds.tier3.amount && tier3ProductExists){
      console.log('Threshold 3 not met, removing product');
      await productRemover(tier3Product.key);
    } else if(tier3Product && tier3Product.quantity > 1){
      await productRemover(tier3Product.key, 1);
    }
  }
  
  if(thresholds.tier4.amount && thresholds.tier4.product){ 
    const tier4ProductExists = cart.items.some(item => item.variant_id == thresholds.tier4.product);
    const tier4Product = cart.items.find(item => item.variant_id == thresholds.tier4.product);
    if(cartTotalExcludingProducts >= thresholds.tier4.amount && !tier4ProductExists){ 
      console.log('Threshold 4 met, adding product');
      await productAdder(thresholds.tier4.product);
    } else if(cartTotalExcludingProducts < thresholds.tier4.amount && tier4ProductExists){
      console.log('Threshold 4 not met, removing product');
      await productRemover(tier4Product.key);
    } else if(tier4Product && tier4Product.quantity > 1){
      await productRemover(tier4Product.key, 1);
    }
  }
}

document.addEventListener("cart:refresh", thresholds);
document.addEventListener("check:thresholds", thresholds);

['cart:refresh', 'wheel:spin', 'theme:loading:end'].forEach(event => {
  document.addEventListener(event, checkPacks);
});

async function checkPacks(event) {
  let cartChange = false;
  await fetch('/cart.js')
  .then(response => response.json())
  .then(async (cart) => {
    for(const product of window.disabledProducts){
      if(cart.items.find(item => item.product_id === product.id)){
        var removePack = true;
      }
    }
    const hasPrize = cart.items.some(
      (item) => item.properties._juneSpinTheWheel === "true"
    );
    const prizes = cart.items.filter(
      (item) => item.properties._juneSpinTheWheel === "true"
    );
    const cartTotal = cart.total_price;

    if ((cartTotal < window.theme.tone_threshold_in_cents && hasPrize) || (removePack && hasPrize)) {
      let gifts = cart.items.filter((item) => {
        return item.properties._juneSpinTheWheel === "true";
      });
      let updates = gifts.reduce((obj, item) => {
        obj[item.id] = 0;
        return obj;
      }, {});

      await fetch(`/cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      })
        .then((response) => response.json())
        .then(() => {
          cartChange = true;
        })
        .catch((error) => {
          console.error("Error removing product from cart:", error);
        });
    } else if(prizes.length > 1 || (prizes.length === 1 && prizes[0].quantity > 1)) {
      let updates = {
        [prizes[0].id]: 1,
      };
      for (let i = 1; i < prizes.length; i++) {
        updates[prizes[i].id] = 0;
      }
      await fetch(`/cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      })
        .then((response) => response.json())
        .then(() => {
          cartChange = true;
        })
        .catch((error) => {
          console.error("Error removing product from cart:", error);
        });
      console.log('updates :>> ', updates);
    }
  });

  if (cartChange) {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );
  }
}

checkPacks();